module.exports = __webpack_public_path__ + "static/img/1.755c4e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/1.png
// module id = d7kY
// module chunks = 0